import { __decorate } from "tslib";
import { attr, customElement } from '@microsoft/fast-element';
import { Button, ButtonTemplate as template } from '@microsoft/fast-foundation';
import { ButtonStyles as styles } from './button.styles';
/**
 * The Fluent Button Element. Implements {@link @microsoft/fast-foundation#Button},
 * {@link @microsoft/fast-foundation#ButtonTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fluent-button\>
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/delegatesFocus | delegatesFocus}
 */
let FluentButton = class FluentButton extends Button {
    appearanceChanged(oldValue, newValue) {
        if (oldValue !== newValue) {
            this.classList.add(newValue);
            this.classList.remove(oldValue);
        }
    }
    /**
     * @internal
     */
    connectedCallback() {
        super.connectedCallback();
        if (!this.appearance) {
            this.appearance = 'neutral';
        }
    }
    /**
     * Applies 'icon-only' class when there is only an SVG in the default slot
     *
     * @internal
     */
    defaultSlottedContentChanged() {
        const slottedElements = this.defaultSlottedContent.filter(x => x.nodeType === Node.ELEMENT_NODE);
        if (slottedElements.length === 1 && slottedElements[0] instanceof SVGElement) {
            this.control.classList.add('icon-only');
        }
        else {
            this.control.classList.remove('icon-only');
        }
    }
};
__decorate([
    attr
], FluentButton.prototype, "appearance", void 0);
FluentButton = __decorate([
    customElement({
        name: 'fluent-button',
        template,
        styles,
        shadowOptions: {
            delegatesFocus: true,
            mode: 'closed',
        },
    })
], FluentButton);
export { FluentButton };
/**
 * Styles for Button
 * @public
 */
export const ButtonStyles = styles;
